import React from 'react';
import { CLIENT_FONTFAMILY_OPTIONS, DEFAULT_FONTFAMILY } from 'src/constants';
import { PortalConfigContext } from 'src/context';
import { useAppSelector } from 'src/hooks/useStore';

export const FontProvider: React.FC = () => {
  const portalConfig = React.useContext(PortalConfigContext);
  const isClient = useAppSelector((state) => state.user.isClient);
  // Only run effect if brand config is present
  React.useEffect(() => {
    if (!portalConfig?.brand) return;
    const { clientFontFamily } = portalConfig.brand;
    let fontFamilyValue: string;
    if (isClient) {
      fontFamilyValue = clientFontFamily
        ? CLIENT_FONTFAMILY_OPTIONS.find((f) => f.value === clientFontFamily)
            ?.label || DEFAULT_FONTFAMILY
        : DEFAULT_FONTFAMILY;
    } else {
      fontFamilyValue = DEFAULT_FONTFAMILY;
    }
    const fontFamilyWithFallbacks = [
      `"${fontFamilyValue}"`,
      '"Helvetica"',
      '"Arial"',
      'sans-serif',
    ].join(',');
    document.documentElement.style.setProperty(
      '--font-primary',
      fontFamilyWithFallbacks,
    );
  }, [portalConfig?.brand?.clientFontFamily, portalConfig?.brand, isClient]);
  if (!portalConfig?.brand) return null;
  return null;
};
